export default __webpack_public_path__ + "static/media/promo-usdt.db802d31.svg";